<template>
  <div class="home" ref="home">
    <!-- <pageAlert></pageAlert> -->
    <el-header>
      <HeaderNav @collapseChange="collapseCall" />
    </el-header>
    <el-container>
      <el-aside width="auto">
        <AsideNav :isCollapse="isCollapse" />
      </el-aside>
      <el-main>
        <PageHistory></PageHistory>
        <div class="content__div" id="content__div" :style="{minWidth: ['/inHouse_check'].includes($route.path) ? '1240px' : ''}">
          <keep-alive max="12" :exclude="pageExclude">
            <router-view v-slot="{ Component }">
              <transition>
                <component :is="Component" />
              </transition>
            </router-view>
          </keep-alive>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
import AsideNav from "@/components/AsideNav";
import HeaderNav from "@/components/HeaderNav";
import PageHistory from "@/components/PageHistory";
import menus from "@/mixins/menus";
// import pageAlert from "@/components/pageAlert"

export default {
  name: 'Home',
  components: {
    PageHistory,
    AsideNav,
    HeaderNav,
    // pageAlert
  },
  mixins: [menus],
  computed: {
    role: function () {
      return this.$store.getters.getUseRole
    },
    pageExclude: function () {
      return this.$store.getters.getPageExclude
    }
  },
  mounted() {
    if (this.role && this.role.length) {
      this.getMenu(this.role)
    }

  },
  data() {
    return {
      isCollapse: false,
      isKeep: true
    }
  },
  methods: {
    collapseCall: function (payload) {
      this.isCollapse = payload
    },
  },
}
</script>
<style scoped lang="stylus">
.home {
  height: 100vh,
}

::v-deep .el-container, ::v-deep .el-aside {
  height: calc(100vh - 60px);
}

::v-deep .el-main {
  position: relative;
  top: 0;
  left: 0;
  height 100vh,
  overflow auto!important
  padding 0
}

::v-deep .el-header {
  padding: 0
}

.content__div {
  margin 10px
  background white
  padding 10px 0
  box-shadow 0 0 20px 10px rgba(0, 0, 0, 0.05)
  border-radius 10px
}

::v-deep .el-main::-webkit-scrollbar {
  width: 4px; /* Chrome Safari */
}
::v-deep .el-main::-webkit-scrollbar-thumb  {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0,0,0,0.2)
}
::v-deep .el-main::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 0;
  background: rgba(0,0,0,0.1);
}

.content__div_anchor{
  height: 1px
  position: relative;
  top:-100px
}
</style>

